import { StackNavigationOptions } from '@react-navigation/stack'
import { ArrowLeft } from 'phosphor-react-native'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import Header from '../components/Header/Header'
import theme from '../design-system/theme'
import { fontFamily } from '../design-system/theme/partners/tokens'

const { colors } = theme

const styles = StyleSheet.create({
  headerTitle: {
    display: 'flex',
    fontFamily: fontFamily,
    fontSize: 16,
  },
  headerTitleHidden: {
    display: 'none',
  },
  headerBackTitle: {
    marginLeft: 4,
    fontSize: 14,
    fontFamily: fontFamily,
  },
})

export function useScreenOptions() {
  const { t } = useTranslation()

  return useMemo(
    () =>
      ({
        headerBackTitle: '',
        headerTruncatedBackTitle: '',
        headerBackTitleVisible: true,
        headerTitleAlign: 'center',
        headerBackTitleStyle: styles.headerBackTitle,
        headerTitleStyle: styles.headerTitleHidden,
        headerTransparent: true,
        headerShown: true,
        header: Header,
        headerTitleAllowFontScaling: true,
        headerBackImage: ArrowLeft,
        headerLeftContainerStyle: { paddingLeft: 8 },
        headerRightContainerStyle: { paddingRight: 8 },
        headerBackgroundContainerStyle: {
          justifyContent: 'center',
          backgroundColor: colors.bg,
          opacity: 0.9,
        },
        cardStyle: {
          width: '100%',
          alignSelf: 'center',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: 0,
          backgroundColor: colors.bg,
        },
      } as StackNavigationOptions),
    [t]
  )
}

export function useWhiteScreenOptions(hideHeader = false) {
  const screenOptions = useScreenOptions()

  return useMemo(
    () => ({
      ...screenOptions,
      headerBackgroundContainerStyle: {
        ...(typeof screenOptions.headerBackgroundContainerStyle === 'object'
          ? screenOptions.headerBackgroundContainerStyle
          : { headerBackgroundContainerStyle: screenOptions.headerBackgroundContainerStyle }),
        backgroundColor: hideHeader ? 'transparent' : 'white',
      },
      cardStyle: {
        ...(typeof screenOptions.cardStyle === 'object'
          ? screenOptions.cardStyle
          : { cardStyle: screenOptions.cardStyle }),
        backgroundColor: 'white',
      },
    }),
    [screenOptions]
  )
}

export function useTabScreenOptions() {
  const { bottom } = useSafeAreaInsets()
  return useMemo(
    () =>
      ({
        headerShown: false,
        tabBarIconStyle: {
          width: 24,
          height: 24,
          color: colors.gray['700'],
          flex: undefined,
        },
        tabBarActiveBackgroundColor: colors.primary['100'],
        tabBarActiveTintColor: colors.gray['900'],
        tabBarInactiveTintColor: colors.gray['700'],
        tabBarStyle: {
          height: 70 + bottom,
          borderTopColor: colors.gray['400'],
          maxWidth: 600,
          alignSelf: 'center',
          width: '100%',
        },
        tabBarItemStyle: {
          borderRadius: 8,
          marginLeft: 4,
          marginRight: 4,
          marginTop: 4,
          marginBottom: 4,
          flexDirection: 'column',
          justifyContent: 'center',
          paddingLeft: 0,
          paddingTop: 4,
          paddingBottom: 4,
          paddingRight: 0,
        },
        tabBarLabelStyle: {
          fontSize: 12,
          marginTop: 10,
        },
      } as const),
    []
  )
}
